<ejs-dialog #modal [isModal]='false' 
    [header]="'Detalhes do Paciente'" 
    [visible]="false"
    [width]="'80%'"
    [height]="'80%'"
    [showCloseIcon]='true' 
    style="position: fixed;"
    (open)="tabOk=true"
    [closeOnEscape]='true'>

    <ng-template #content>
        <ng-container *ngTemplateOutlet="tab"></ng-container>
    </ng-template>
</ejs-dialog>

<ng-template #tab>
    <ejs-tab class='e-fill' #tab (selecting)="mudandoTab($event)" *ngIf="tabOk">
        <div class="e-tab-header">
            <div>Gerais </div>
            <div>Doenças</div>
            <div>Periodicidades</div>
            <div>Lotações/Atribuições</div>
            <div>Exposição (Agentes)</div>
            <div>História Clínica</div>
        </div>
        <div class="e-content">
            <div class="content">
                <ng-container *ngTemplateOutlet="geral"></ng-container>
            </div>
            <div class="content">
                <app-paciente-doenca-lista #doencaLista></app-paciente-doenca-lista>
            </div>
            <div class="content">
                <app-paciente-periodicidade-lista #periodicidadeLista></app-paciente-periodicidade-lista>
            </div>
            <div class="content">
                <app-paciente-lotacao-lista #lotacaoLista></app-paciente-lotacao-lista>
            </div>
            <div class="content">
                <app-paciente-agente-lista (lotacaoAtribuicaoId)="lotacaoSelecaoAtualId=$event" #agenteLista></app-paciente-agente-lista>
            </div>
            <div class="content">
                <app-paciente-historia-lista  #historiaLista></app-paciente-historia-lista>
            </div>
        </div>
    </ejs-tab>
</ng-template>



<ng-template #geral>
    <div [formGroup]='modelo'>
        <div class="row">
            <div class='form-group col-md-2'>
                <ejs-textbox 
                [floatLabelType]="'Always'" formControlName="id"
                                [placeholder]="'ID'" [enabled]="false" label='Id'>
                </ejs-textbox>
            </div>
            <div class='form-group col-md-10'>
                <ejs-textbox 
                [floatLabelType]="'Always'" formControlName="nome"
                                [placeholder]="'Nome'" [enabled]="false" [readonly]="true" label='Id'>
                </ejs-textbox>
            </div>
        </div>

        <div class="row">
            <div class='form-group col-md-4'>
                <ejs-textbox 
                [floatLabelType]="'Always'" formControlName="cpf"
                                [placeholder]="'CPF'" [enabled]="false" label='Id'>
                </ejs-textbox>
            </div>
            <div class='form-group col-md-4'>
                <ejs-textbox 
                [floatLabelType]="'Always'" formControlName='rg'
                                [placeholder]="'RG'" [enabled]="false" label='Id'>
                </ejs-textbox>
            </div>
            <div class='form-group col-md-4'>
                <ejs-textbox 
                [floatLabelType]="'Always'" formControlName="pis"
                                [placeholder]="'PIS'" [enabled]="false" label='Id'>
                </ejs-textbox>
            </div>
        </div>

        <div class="row">
            <div class='form-group col-md-4'>
                <ejs-datepicker 
                [floatLabelType]="'Always'" formControlName="dataNascimento" [enabled]="false" 
                                [placeholder]="'Nascimento'" label='Id'>
                </ejs-datepicker>
            </div>
            <div class='form-group col-md-4'>
                <ejs-textbox 
                [floatLabelType]="'Always'" formControlName="idade" [enabled]="false" 
                                [placeholder]="'Idade'" label='Id'>
                </ejs-textbox>
            </div>
            <div class='form-group col-md-4'>
                <ejs-textbox 
                [floatLabelType]="'Always'" formControlName="sexo" [enabled]="false" 
                                [placeholder]="'Sexo'" [readonly]="true" label='Id'>
                </ejs-textbox>
            </div>
        </div>
    </div>
</ng-template>



